<ng-container *transloco="let t; prefix: 'organizations.detailPage.riskAnalysisDeliveryTab.documents.uploadDialog'">
  <aml-modal-wrapper [title]="t('title')" [size]="ModalSizeMap.lg" (dismiss)="cancel()">
    <div class="b-result-upload">
      <p class="b-result-upload__subtitle">
        {{ deliveryTracker.organizationDisplayName }}
      </p>

      <div class="b-result-upload__body">
        <ng-container *transloco="let tShared; prefix: 'fileUpload'">
          <aml-file-input
            [showFileDropArea]="true"
            [multiple]="true"
            [maxFiles]="uploadLimits.maxFiles"
            [maxFileSize]="uploadLimits.maxFileSize"
            [allowedFileExtensions]="uploadLimits.allowedFileExtensions"
            [existingFileNames]="stagedFiles.fileNames()"
            [disabled]="isDelivering() || stagedFiles.remainingSlots() === 0"
            [selectFilesLabel]="tShared('selectFiles')"
            [showFileExtensionDescription]="true"
            [showMaxNoOfFilesDescription]="true"
            [showFileSizeDescription]="true"
            (selectedFiles)="stagedFiles.add($event)"
          />

          @if (stagedFiles.wasSelectionTruncated()) {
            <p class="b-result-upload__limit">{{ tShared('tooManyFiles', { count: uploadLimits.maxFiles }) }}</p>
          }
        </ng-container>

        @if (stagedFiles.files().length === 0) {
          <p class="b-result-upload__empty">{{ t('noFilesSelected') }}</p>
        } @else {
          <aad-staged-file-list
            [files]="stagedFiles.files()"
            [contentTypeOptions]="contentTypeOptions()"
            [disabled]="isDelivering()"
            (filePatched)="onFilePatched($event)"
            (fileRemoved)="stagedFiles.remove($event)"
          />
        }

        <div class="b-result-upload__notify" [class.b-result-upload__notify--unavailable]="!canCloseAndNotify">
          <label
            nz-checkbox
            [nzDisabled]="!canCloseAndNotify || isDelivering()"
            [ngModel]="closeTrackerAndNotify()"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="closeTrackerAndNotify.set($event)"
          >
            <span class="b-result-upload__notify-text">
              <span class="b-result-upload__notify-title">
                {{ isNotifyOnly ? t('notifyCustomer.label') : t('closeAndNotify.label') }}
              </span>
              <span class="b-result-upload__notify-description">
                @if (isNotifyOnly) {
                  {{ t('notifyCustomer.description') }}
                } @else if (canCloseAndNotify) {
                  {{ t('closeAndNotify.description') }}
                } @else {
                  {{ t('closeAndNotify.unavailable', { status: trackerStatusLabel() }) }}
                }
              </span>
            </span>
          </label>
        </div>
      </div>

      <footer class="b-result-upload__footer">
        <span class="b-result-upload__hint">
          @if (stagedFiles.files().length === 0) {
            {{ t('hints.noFiles') }}
          } @else if (untypedFileCount() > 0) {
            {{ t('hints.untypedFiles', { count: untypedFileCount() }) }}
          } @else {
            {{ t('hints.readyToDeliver', { count: stagedFiles.files().length }) }}
          }
        </span>

        <div class="b-result-upload__actions">
          <aml-button [variant]="ButtonVariantMap.secondary" [disabled]="isDelivering()" (buttonClicked)="cancel()">
            {{ t('actions.cancel') }}
          </aml-button>
          <aml-button [variant]="ButtonVariantMap.primary" [disabled]="!canSubmit()" (buttonClicked)="submit()">
            {{ t('actions.submit') }}
          </aml-button>
        </div>
      </footer>

      <aad-busy-overlay
        *transloco="let tShared; prefix: 'fileUpload'"
        [isBusy]="isDelivering()"
        [label]="tShared('status.uploading')"
      />
    </div>
  </aml-modal-wrapper>
</ng-container>
